import { render, staticRenderFns } from "./Prepaymentverification.vue?vue&type=template&id=2da2b17b&scoped=true"
import script from "./Prepaymentverification.vue?vue&type=script&lang=js"
export * from "./Prepaymentverification.vue?vue&type=script&lang=js"
import style0 from "./Prepaymentverification.vue?vue&type=style&index=0&id=2da2b17b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da2b17b",
  null
  
)

export default component.exports